import { SearchAdapter, SuggestionsRequest, SuggestionsResponse } from '@empathy/search-adapter';
import { container } from '../../../container';
import { DEPENDENCIES } from '../../../container/dependencies.const';
import { EmpathizeState, EmpathyXConfig } from '../../../models';
import { catchAdapterError } from '../../../utils';
import { GETTERS_KEYS } from '../../store.const';
import { EMPATHIZE_ACTIONS_KEYS, EMPATHIZE_MUTATIONS_KEYS } from '../empathize.const';
import { EmpathizeAction, EmpathizeContext } from '../empathize.interfaces';

export class GetPopularSearchesAction implements EmpathizeAction {
  actions = {
    [EMPATHIZE_ACTIONS_KEYS.getPopularSearches]: ({ commit, rootGetters }: EmpathizeContext): void => {
      const platformAdapter: SearchAdapter = container.get<SearchAdapter>(DEPENDENCIES.Adapter);
      const { popularSearches }: EmpathyXConfig = rootGetters[GETTERS_KEYS.config.config];
      const request: SuggestionsRequest = { rows: popularSearches.size };
      commit(EMPATHIZE_MUTATIONS_KEYS.setLoading, true);
      platformAdapter.getSuggestions(request, {requestId: 'popular-searches'})
        .then((response: SuggestionsResponse) => {
          commit(EMPATHIZE_MUTATIONS_KEYS.saveEmpathizeResponse, { popularSearches: response.suggestions } as Partial<EmpathizeState>);
          commit(EMPATHIZE_MUTATIONS_KEYS.setLoading, false);
        })
        .catch(catchAdapterError('Popular Searches'));
    }
  };
}
